import {Input} from 'antd';
import React, {FC} from 'react';

import {IFieldMeta} from 'entities/metadata';
import {ReactComponent as Lock} from 'shared/assets/forms/lock.svg';
import {useGetAppPropertyQuery} from 'store/api/app-properties/app-properties.api';

interface IInputStringProps {
    disabled: boolean;
    autoComplete: string;
    field?: IFieldMeta;
    value: any;
    defaultValue?: string;
    propertyCodeValue?: string;
}

export const InputString: FC<IInputStringProps> = (
    {
        disabled,
        autoComplete,
        propertyCodeValue,
        field,
        value,
        ...props
    }: IInputStringProps,
) => {
    const {data: valuePropertyCode} = useGetAppPropertyQuery(
        {propertyCode: propertyCodeValue}, {skip: !propertyCodeValue},
    );

    const suffix = disabled ? <Lock /> : null;
    return (
        <Input
            disabled={disabled}
            suffix={suffix}
            autoComplete={autoComplete}
            defaultValue={field?.defaultValue?.toString()}
            value={value || valuePropertyCode}
            {...props}
        />
    );
};
